import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../../atoms/Grid/Grid';
import InputControl from '../../atoms/InputControl/InputControl';
import Button from '../../atoms/Button/Button';
import { addCountryInitAction, fetchCountriesAction } from '../../../actions/countriesActions';
import Api from '../../../services/Api';

const CountryModal = ({
  country,
  onRequestClose,
}) => {
  const [name, setName] = useState(country ? country.name : undefined);
  const [code, setCode] = useState(country ? country.code : undefined);
  const [nameValidation, setNameValidation] = useState(undefined);
  const [codeValidation, setCodeValidation] = useState(undefined);
  const {
    addCountryError,
    isAddingCountry,
    didSuccessfullyAddCountry,
  } = useSelector(state => state.countries);
  const dispatch = useDispatch();
  useEffect(() => {
    if (didSuccessfullyAddCountry) {
      dispatch(fetchCountriesAction());
      onRequestClose();
    }
  }, [didSuccessfullyAddCountry]);
  const onSave = () => {
    const body = {
      name,
      code,
    };
    if (!country) {
      dispatch(addCountryInitAction(body));
      return;
    }
    Api.patch(`countries/${country.id}`, body, false).then(({ status }) => {
      if (status === 200) {
        if (onRequestClose) {
          onRequestClose();
        }
      }
    });
  };
  return (
    <Grid>
      <div className="col-md-12">
        <InputControl
          placeholder="Country name..."
          label="Name"
          onValueChanged={(val) => {
            setName(val);
            setNameValidation(undefined);
          }}
          isErrorShown={nameValidation !== undefined}
          errorMessage={nameValidation}
          initialValue={name}
        />
      </div>
      <div className="col-md-12" style={{ marginTop: '10px' }}>
        <InputControl
          placeholder="Country code..."
          label="Code"
          onValueChanged={(val) => {
            setCode(val);
            setCodeValidation(undefined);
          }}
          isErrorShown={codeValidation !== undefined}
          errorMessage={codeValidation}
          initialValue={code}
        />
      </div>
      {addCountryError && (
        <div className="col-md-12">
          <small>{addCountryError}</small>
        </div>
      )}
      <div className="col-md-12" style={{ marginTop: '10px' }}>
        <Button isLoading={isAddingCountry} label="Save" onInvoked={onSave} />
      </div>
    </Grid>
  );
};

CountryModal.propTypes = {
  country: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  })),
  onRequestClose: PropTypes.func.isRequired,
};

CountryModal.defaultProps = {
  country: undefined,
};

export default CountryModal;
